export const notePermissions = {
    DELETE: {
        key: 'Note.Delete',
        name: 'Allow delete note',
    }
}